"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _get = _interopRequireDefault(require("lodash/get"));

var _union = _interopRequireDefault(require("lodash/union"));

var _hoistNonReactStatics = _interopRequireDefault(require("hoist-non-react-statics"));

var _Grid = _interopRequireDefault(require("lemon-ui/lib/collections/Grid"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var responsiveContainerOptionsDefault = {
  isMultiline: true,
  isCentered: true,
  isGapless: true,
  hasWrapper: true,
  responsive: 'isMobile'
};

var _default = function _default() {
  var responsiveOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var defaultResponsiveMapping = arguments.length > 1 ? arguments[1] : undefined;
  var responsiveContainerOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : responsiveContainerOptionsDefault;
  var isResponsive = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var hasResponsiveContainer = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
  return function (WrappedComponent) {
    var defaultProps = _objectSpread(_objectSpread({}, WrappedComponent.defaultProps), {}, {
      isResponsive: WrappedComponent.defaultProps.isResponsive || isResponsive,
      hasResponsiveContainer: WrappedComponent.defaultProps.hasResponsiveContainer || hasResponsiveContainer,
      responsiveOptions: WrappedComponent.defaultProps.responsiveOptions || responsiveOptions,
      responsiveContainerOptions: WrappedComponent.defaultProps.responsiveContainerOptions || responsiveContainerOptions,
      responsiveMapping: WrappedComponent.defaultProps.responsiveMapping || defaultResponsiveMapping
    });

    var Responsive = /*#__PURE__*/function (_Component) {
      _inherits(Responsive, _Component);

      var _super = _createSuper(Responsive);

      function Responsive(props) {
        _classCallCheck(this, Responsive);

        return _super.call(this, props);
      }

      _createClass(Responsive, [{
        key: "render",
        value: function render() {
          var _this$props = this.props,
              isResponsive = _this$props.isResponsive,
              hasResponsiveContainer = _this$props.hasResponsiveContainer,
              responsiveOptions = _this$props.responsiveOptions,
              responsiveContainerOptions = _this$props.responsiveContainerOptions,
              responsiveMapping = _this$props.responsiveMapping,
              innerRef = _this$props.innerRef,
              additionalStyles = _this$props.additionalStyles,
              props = _objectWithoutProperties(_this$props, ["isResponsive", "hasResponsiveContainer", "responsiveOptions", "responsiveContainerOptions", "responsiveMapping", "innerRef", "additionalStyles"]);

          var wrappedComponent = /*#__PURE__*/_react["default"].createElement(WrappedComponent, _extends({}, props, {
            isResponsive: isResponsive,
            ref: innerRef
          }));

          var element = wrappedComponent;

          if (isResponsive) {
            // const mergedResponsiveOptions = merge( {},
            //     defaultProps.responsiveOptions,
            //     responsiveOptions
            // );
            // const mergedResponsiveContainerOptions = merge( {},
            //     defaultProps.responsiveContainerOptions,
            //     responsiveContainerOptions
            // );
            var size = responsiveOptions.size,
                offset = responsiveOptions.offset;
            var mappedSize = size;
            var hasResponsiveMapping = !!responsiveMapping;

            if (hasResponsiveMapping) {
              var mapping = responsiveMapping;

              if (mapping && !mapping.length) {
                mapping = defaultResponsiveMapping;
              }

              mappedSize = mapping.map(function (entry) {
                var propValue = (0, _get["default"])(props, entry.path);
                var value = entry.map[propValue];

                if (Array.isArray(value)) {
                  return value;
                }

                return [value];
              });
              mappedSize = _union["default"].apply(void 0, _toConsumableArray(mappedSize));
            }

            var insideGrid = /*#__PURE__*/_react["default"].createElement(_Grid["default"].Column, {
              size: mappedSize,
              offset: offset,
              style: _objectSpread({
                maxWidth: '100vw'
              }, additionalStyles)
            }, wrappedComponent);

            element = insideGrid;

            if (hasResponsiveContainer) {
              var style = {}; // only from boxed components
              //

              if (props.boxed && props.box && props.box.bgColor) {
                style.backgroundColor = props.box.bgColor;
              }

              element = /*#__PURE__*/_react["default"].createElement(_Grid["default"].Columns, _extends({}, responsiveContainerOptions, {
                style: style,
                className: "responsive"
              }), insideGrid);
            }
          }

          return element;
        }
      }]);

      return Responsive;
    }(_react.Component);

    _defineProperty(Responsive, "displayName", "Responsive".concat(WrappedComponent.displayName));

    _defineProperty(Responsive, "propTypes", _objectSpread(_objectSpread({}, WrappedComponent.propTypes), {}, {
      isResponsive: _propTypes["default"].bool,
      hasResponsiveContainer: _propTypes["default"].bool,
      additionalStyles: _propTypes["default"].object,
      responsiveOptions: _propTypes["default"].shape({
        size: _Grid["default"].Column.propTypes.size,
        offset: _Grid["default"].Column.propTypes.offset
      }),
      responsiveContainerOptions: _propTypes["default"].shape({
        responsive: _Grid["default"].Columns.propTypes.responsive,
        isGapless: _Grid["default"].Columns.propTypes.isGapless,
        isMultiline: _Grid["default"].Columns.propTypes.isMultiline,
        isVcentered: _Grid["default"].Columns.propTypes.isVcentered,
        isCentered: _Grid["default"].Columns.propTypes.isCentered
      }),
      responsiveMapping: _propTypes["default"].arrayOf(_propTypes["default"].shape({
        path: _propTypes["default"].string,
        map: _propTypes["default"].object
      }))
    }));

    _defineProperty(Responsive, "defaultProps", defaultProps);

    return (0, _hoistNonReactStatics["default"])(Responsive, WrappedComponent);
  };
};

exports["default"] = _default;